import { useId } from 'preact/compat'
import clsx from 'clsx'
import useHydrated from 'landing_pages/common/useHydrated'
import PlaceholderInput from './PlaceholderInput'
import { ComponentChildren } from 'preact'

export type NativeSelectItemProps = {
  value: string
  label?: string
  disabled?: boolean
  hidden?: boolean
}

export function NativeSelectItem({ value, label, disabled = false, hidden = false }: NativeSelectItemProps) {
  return (
    <option value={value} disabled={disabled} style={{ display: hidden ? 'none' : undefined }}>
      {label || value}
    </option>
  )
}

export type NativeSelectProps = {
  label: string
  value: string
  onChange: (value: string) => void
  showLabel?: boolean
  disabled?: boolean
  name?: string
  placeholder?: string
  error?: boolean
  children?: ComponentChildren
}

export default function NativeSelect({
  label,
  value,
  onChange,
  showLabel = true,
  disabled = false,
  name,
  placeholder,
  error = false,
  children
}: NativeSelectProps) {
  const hydrated = useHydrated()
  const selectId = useId()

  if (!hydrated) {
    return <PlaceholderInput marginTop={showLabel ? '25px' : '0px'} />
  }

  return (
    <div className={clsx('native-select', 'input-container input-container-select', error && 'error')} style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
      {showLabel && (
        <label
          className="input-container-select-label"
          htmlFor={selectId}
          style={{ cursor: 'pointer', display: 'block', marginTop: 4, justifySelf: 'left' }}
        >
          {label}
        </label>
      )}

      <select
        id={selectId}
        name={name}
        value={value}
        onChange={e => onChange(e.currentTarget.value)}
        disabled={disabled}
        aria-label={label}
        className={error ? 'error' : undefined}
        style={{
          width: '100%',
          padding: '0.5rem 1rem',
          appearance: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          backgroundColor: 'white',
          border: '1px solid #ccc',
          borderRadius: 4,
          position: 'relative',
          zIndex: 1,
          marginBottom: 0,
        }}
      >
        {placeholder && <option value="" style={{ display: 'none' }}>{placeholder}</option>}
        {children}
      </select>
    </div>
  )
}
